import { useContext, useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { autorun } from 'mobx';
import { useLocation } from 'react-router-dom';

import { RootStoreContext } from 'index';

/**
 * Attaches only non-PII identifiers to Sentry events. Everything sent here is an internal id,
 * enum or static route path — never names, email, phone, federal tax id or tokens.
 * Clears itself on logout (account becomes null -> user and tags are reset).
 */
export const useSentryContext = () => {
  const { authStore, prequalificationStore } = useContext(RootStoreContext);
  const { pathname } = useLocation();

  useEffect(() => {
    return autorun(() => {
      const account = authStore.account;

      Sentry.setUser(account ? { id: String(account.id) } : null);
      Sentry.setTag('intermediaryId', account?.intermediaryId ?? null);
      Sentry.setTag('intermediaryApplicationId', prequalificationStore.intermediaryApplicationId ?? null);
      Sentry.setContext('portal', {
        accountStatus: account?.accountStatus ?? null,
        registrationStep: prequalificationStore.currentStep ?? null,
        registrationEntrySource: prequalificationStore.prequalificationEntrySource ?? null,
      });
    });
  }, [authStore, prequalificationStore]);

  useEffect(() => {
    Sentry.setContext('route', { path: pathname });
  }, [pathname]);
};
